import { createContext } from 'react';
import { CurrencyDto } from 'types';

interface CurrencySelectionContextValue {
  currencies: CurrencyDto[];
  currencyOptions: { value: string; label: string }[];
  currenciesLoading: boolean;
  currenciesError: Error | null;
  selectedCurrency: string;
  setSelectedCurrency: (currency: string) => void;
}

export const CurrencySelectionContext = createContext<CurrencySelectionContextValue | null>(null);
